import { ExamplePageTemplate } from "./components";
import { educationConfig } from "./configs/exampleConfigs";

const EducationExample = () => {
  return (
    <ExamplePageTemplate
      backgroundColor={educationConfig.backgroundColor}
      chatButtonColor={educationConfig.chatButtonColor}
      chatButtonIcon={educationConfig.chatButtonIcon}
      header={educationConfig.header}
      hero={educationConfig.hero}
    >
      {educationConfig.content}
    </ExamplePageTemplate>
  );
};

export default EducationExample;